/** @type {import('./index').NetworkConfig} */
const facebook = {
  name: 'Facebook',
  sort: 4,
  baseUrl: 'https://www.facebook.com/',
  domains: ['facebook.com', 'fb.com'],
  supported: false, // Feature-flagged off per requirements
  color: '#1877F2',
  hasVideoContent: false,
  supportsEmbed: false,
  requiresReferrer: false,
};

export default facebook;
